/*
 * `datetime-local` inputs work in the browser's local time without a zone. Content stores Unix milliseconds (UTC)
 * (trigger rules' `activeFrom`/`activeUntil`), and the API takes ISO instants (code windows). These convert both ways.
 */

/** A Unix-ms instant as a `datetime-local` value in the browser's local time ('' for none). */
export function msToLocalInput(ms: number | null | undefined): string {
  if (ms == null || !Number.isFinite(ms)) return '';
  const d = new Date(ms);
  return new Date(d.getTime() - d.getTimezoneOffset() * 60_000).toISOString().slice(0, 16);
}

/** A `datetime-local` value (local time) as Unix ms, or null when empty or unparsable. */
export function localInputToMs(local: string): number | null {
  if (!local) return null;
  const ms = new Date(local).getTime();
  return Number.isFinite(ms) ? ms : null;
}

/** A `datetime-local` value (local time) as an ISO instant, or null when empty. */
export function localInputToIso(local: string): string | null {
  const ms = localInputToMs(local);
  return ms == null ? null : new Date(ms).toISOString();
}

/** An ISO instant as a `datetime-local` value in the browser's local time. */
export function isoToLocalInput(iso: string | null | undefined): string {
  return iso ? msToLocalInput(new Date(iso).getTime()) : '';
}

/** An ISO instant in the browser's locale, or ''. */
export const when = (iso: string | null | undefined) => (iso ? new Date(iso).toLocaleString() : '');
